<script>
import { etatPanierItemProps } from "./mixin";
import Button from "@/components/atoms/button";
import LazyImage from "@/components/atoms/lazy-image";
import ListItem from "@/components/molecules/list/list-item";

export default {
  name: "EtatPanierItem",
  components: {
    Button,
    LazyImage,
    ListItem
  },
  props: {
    ...etatPanierItemProps()
  },
  emits: ["showSimilaires"]
};
</script>

<template>
  <ListItem :class="showSimilaires ? 'c-popin-panier-rupture-partielle__deleted-item' : 'u-flex'">
    <LazyImage
      :src="article.visuel"
      width="64"
      height="64"
      class="u-flex-shrink-none u-mr-xs"
    />
    <div class="u-flex-grow">
      <p class="u-text-left u-mb-sm">
        {{ article.designation }}
      </p>
      <template v-if="showQuantiteInsuffisante">
        <div class="u-font-14 u-flex u-flex-justify-between u-mb-xs">
          <p class="u-color-text-light">
            Quantité commandée :
          </p>
          <div class="c-popin-panier-rupture-partielle__quantity-ordered">
            <del>x {{ article.old_quantite }}</del>
          </div>
        </div>
        <div class="u-font-14 u-flex u-flex-justify-between">
          <p class="u-color-text-light">
            Quantité modifiée :
          </p>
          <div class="c-popin-panier-rupture-partielle__quantity-modified">
            x {{ article.new_quantite }}
          </div>
        </div>
      </template>
      <Button
        v-else-if="showSimilaires"
        radius="full"
        variant="primary"
        size="sm"
        @click="$emit('showSimilaires')"
      >
        Voir les produits similaires
      </Button>
    </div>
  </ListItem>
</template>

<style lang="scss" scoped>
@import "@/assets/styles/components/popin-panier-rupture-partielle.scss";
</style>
